module.exports = __webpack_public_path__ + "img/minimum_stock.04040b25.svg";